import { MapEntity } from "api/map";

import { HzWell } from "models/threed-viewer";

/**
 * Updates well colors based on mapEntities data.
 * Extracted from ThreeDViewer useEffect for testability.
 *
 * `parentByUwi` maps a subordinate well's UWI (leg/inj) to its parent well's UWI.
 * Subordinate wells carry a synthetic `legUwi` / auto-added inj uwi that the map
 * filter endpoint never returns, so they never match an entity directly — they
 * inherit the parent's filtered colour instead.
 */
export function updateThreeDViewerColours(
  hzWells: HzWell[],
  mapEntities: MapEntity[],
  parentByUwi: Record<string, string> = {}
): HzWell[] {
  const entitiesDict: { [uwi: string]: MapEntity } = {};
  for (const ent of mapEntities) {
    entitiesDict[ent.uwi] = ent;
  }

  return hzWells.map((well) => {
    const entity = entitiesDict[well.UnformattedUwi];
    if (entity?.color) {
      return { ...well, Color: parseInt(entity.color.substr(1), 16) };
    }
    // Subordinate wells aren't returned by the filter endpoint — fall back to the
    // parent well's filtered colour so legs/inj recolour with their parent.
    const parentEntity = entitiesDict[parentByUwi[well.UnformattedUwi]];
    if (parentEntity?.color) {
      return { ...well, Color: parseInt(parentEntity.color.substr(1), 16) };
    }
    return well;
  });
}
